import { Col } from "reactstrap";
import { UnOrderListTitle } from "../../../../constants";
import { UnOrderListData } from "../../../../data/uiKits/Typography";

const UnOrderList = () => {
  return (
    <Col md="6" xxl="4">
      <div className="card-wrapper border rounded-3">
        <h6 className="sub-title fw-bold">{UnOrderListTitle}</h6>
        <ul>{UnOrderListData && UnOrderListData.map((item, index) => <li key={index}>{item}</li>)}</ul>
      </div>
    </Col>
  );
};
export default UnOrderList;
